import { useEffect } from 'react'
import { useAdminAuth } from '../hooks/useAdminAuth.js'
import { setTokenGetter } from '../services/api.js'

const AuthInitializer = ({ children }) => {
  const { getAccessTokenSilently, isAuthenticated } = useAdminAuth()

  useEffect(() => {
    if (isAuthenticated) {
      setTokenGetter(getAccessTokenSilently)
    }
  }, [isAuthenticated, getAccessTokenSilently])

  return children
}

export default AuthInitializer
